// extracted by mini-css-extract-plugin
export default {"dec":"ProjectItem_dec__uupkt","img":"ProjectItem_img__DdqS-","info":"ProjectItem_info__FeojQ","style":"ProjectItem_style__EVd+Z"};